
import { i18nText } from '@/locales';
import { RouterNameEnum } from '@/router/router.types';

export const VisitsRoutes = [
    {
        path: '/visits',
        redirect: 'visits/index',
        component: (): any => import('@/UI/layouts/MainLayout.vue'),
        meta: {
            auth: true,
        },
        children: [
            {
                path: 'index',
                name: RouterNameEnum.Visits,
                meta: {
                    title: i18nText("Журнал записи - EPILIER"),
                    breadcrumb: [{ name: i18nText("Журнал записи") }],
                },
                component: (): any => import('@/UI/pages/visits/Visits.vue'),
            },
            {
                path: 'visit_detail/:id',
                name: RouterNameEnum.VisitsDetail,
                meta: {
                    title: i18nText("Запись клиента - EPILIER"),
                },
                component: (): any => import('@/UI/pages/visits/VisitDetail.vue'),
            },
        ],
    },
];
